import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const RouteInputForm = ({ onCalculate, isCalculating }) => {
  const [departure, setDeparture] = useState('');
  const [destination, setDestination] = useState('');
  const [showDepartureSuggestions, setShowDepartureSuggestions] = useState(false);
  const [showDestinationSuggestions, setShowDestinationSuggestions] = useState(false);

  const norwegianLocations = [
    'Oslo',
    'Bergen',
    'Trondheim',
    'Stavanger',
    'Kristiansand',
    'Drammen',
    'Fredrikstad',
    'Tromsø',
    'Sandnes',
    'Ålesund',
    'Bodø',
    'Haugesund',
    'Tønsberg',
    'Moss',
    'Sandefjord'
  ];

  const handleDepartureChange = (e) => {
    setDeparture(e?.target?.value);
    setShowDepartureSuggestions(e?.target?.value?.length > 0);
  };

  const handleDestinationChange = (e) => {
    setDestination(e?.target?.value);
    setShowDestinationSuggestions(e?.target?.value?.length > 0);
  };

  const selectLocation = (location, type) => {
    if (type === 'departure') {
      setDeparture(location);
      setShowDepartureSuggestions(false);
    } else {
      setDestination(location);
      setShowDestinationSuggestions(false);
    }
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (departure && destination) {
      onCalculate({ departure, destination });
    }
  };

  const swapLocations = () => {
    const temp = departure;
    setDeparture(destination);
    setDestination(temp);
  };

  const filteredDepartures = norwegianLocations?.filter(loc =>
    loc?.toLowerCase()?.includes(departure?.toLowerCase())
  );

  const filteredDestinations = norwegianLocations?.filter(loc =>
    loc?.toLowerCase()?.includes(destination?.toLowerCase())
  );

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="space-y-4 md:space-y-6">
        <div className="relative">
          <Input
            label="Fra"
            type="text"
            placeholder="Skriv inn avgangssted"
            value={departure}
            onChange={handleDepartureChange}
            onFocus={() => setShowDepartureSuggestions(departure?.length > 0)}
            onBlur={() => setTimeout(() => setShowDepartureSuggestions(false), 200)}
            required
            className="w-full"
          />
          {showDepartureSuggestions && filteredDepartures?.length > 0 && (
            <div
              className="absolute z-10 w-full mt-2 bg-card border-2 border-border overflow-hidden"
              style={{ borderRadius: 'var(--radius-sm)' }}
            >
              <div className="max-h-48 overflow-y-auto scrollbar-custom">
                {filteredDepartures?.map((location) => (
                  <button
                    key={location}
                    type="button"
                    onClick={() => selectLocation(location, 'departure')}
                    className="w-full px-4 py-3 text-left text-sm hover:bg-muted transition-colors text-foreground"
                  >
                    <div className="flex items-center gap-3">
                      <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
                      {location}
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="flex justify-center">
          <button
            type="button"
            onClick={swapLocations}
            className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-muted border-2 border-border hover:border-primary transition-all"
            style={{ borderRadius: 'var(--radius-sm)' }}
            aria-label="Swap departure and destination"
          >
            <Icon name="ArrowUpDown" size={20} color="var(--color-foreground)" />
          </button>
        </div>

        <div className="relative">
          <Input
            label="Til"
            type="text"
            placeholder="Skriv inn destinasjon"
            value={destination}
            onChange={handleDestinationChange}
            onFocus={() => setShowDestinationSuggestions(destination?.length > 0)}
            onBlur={() => setTimeout(() => setShowDestinationSuggestions(false), 200)}
            required
            className="w-full"
          />
          {showDestinationSuggestions && filteredDestinations?.length > 0 && (
            <div
              className="absolute z-10 w-full mt-2 bg-card border-2 border-border overflow-hidden"
              style={{ borderRadius: 'var(--radius-sm)' }}
            >
              <div className="max-h-48 overflow-y-auto scrollbar-custom">
                {filteredDestinations?.map((location) => (
                  <button
                    key={location}
                    type="button"
                    onClick={() => selectLocation(location, 'destination')}
                    className="w-full px-4 py-3 text-left text-sm hover:bg-muted transition-colors text-foreground"
                  >
                    <div className="flex items-center gap-3">
                      <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
                      {location}
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        <Button
          type="submit"
          variant="default"
          fullWidth
          loading={isCalculating}
          iconName="Calculator"
          iconPosition="left"
          disabled={!departure || !destination}
        >
          Beregn bomkostnader
        </Button>
      </div>
    </form>
  );
};

export default RouteInputForm;